import { render } from "./ProfileSection.vue?vue&type=template&id=5c69eb8e&scoped=true"
import script from "./ProfileSection.vue?vue&type=script&lang=js"
export * from "./ProfileSection.vue?vue&type=script&lang=js"

import "./ProfileSection.vue?vue&type=style&index=0&id=5c69eb8e&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c69eb8e"]])

export default __exports__